"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};

exports.default = reduceHexValue;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/polished/lib/internalHelpers/_reduceHexValue.js
 ** module id = 475
 ** module chunks = 0
 **/